import { HttpResponse } from '@ppvrbh/merchant-frontend-core';

export interface PostCustomReportCallbackParams {
    onSuccess: () => void;
    onFailure: () => void;
}

export interface GetCustomReportsCallbackParams {
    onSuccess: (data: any) => void;
    onFailure: () => void;
}

function* postCustomReportHandler(
    resp: HttpResponse,
    callbackParams: PostCustomReportCallbackParams,
) {
    if (resp.success) {
        yield callbackParams.onSuccess();
    } else {
        yield callbackParams.onFailure();
    }
}

function* getCustomReportsHandler(
    resp: HttpResponse,
    callbackParams: GetCustomReportsCallbackParams,
) {
    if (resp.success) {
        yield callbackParams.onSuccess(resp.data);
    } else {
        yield callbackParams.onFailure();
    }
}

export interface DownloadCustomReportCallbackParams {
    onSuccess: (downloadUrl: string) => void;
    onFailure: () => void;
}

function* downloadCustomReportHandler(
    resp: HttpResponse,
    callbackParams: DownloadCustomReportCallbackParams,
) {
    if (resp.success) {
        yield callbackParams.onSuccess(resp.data?.url);
    } else {
        yield callbackParams.onFailure();
    }
}

export const customReportSagas = {
    postCustomReportHandler,
    getCustomReportsHandler,
    downloadCustomReportHandler,
};
